import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PopupMessageComponent} from "./popup-message.component";
import {PopupMessageService} from "./popup-message.service";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PopupMessageComponent,
  ],
  exports: [
    PopupMessageComponent
  ],
  providers: [
    PopupMessageService
  ]
})
export class PopupMessageModule { }



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_commonComp/popup-message/popup-message.module.ts